import { get } from 'lodash'
import { call, put, select, takeLatest, SelectEffect, PutEffect, CallEffect } from 'redux-saga/effects'

import AccountsApi from '../../../../api/AccountsApi'
import Errors from '../../../../constants/Errors'
import { fetchActivations } from '../../../../redux/activations/actions'
import localize from '../../../Localize/localize'
import { buildAccountActivationsRequest, buildInternalAccountActivationsRequest } from '../../helpers/requestBuilders'
import {
  activateAccountFailed,
  activateAccountSuccess,
  activateAccountSent,
  activateInternalAccountSent,
  activateInternalAccountSuccess,
  activateInternalAccountFailed,
  setLoading,
  updateAccountActivationSuccess, updateAccountActivationFailed
} from '../actions'
import { accountDetailsSelector, isShouldSkipCRMFlow } from '../selectors'
import { ACTIVATE_ACCOUNT, UPDATE_ACCOUNT_ACTIVATION, ACTIVATE_ACCOUNT_INTERNAL } from '../types'
import messageDispatcher from '../../../Messages/redux/messageDispatcher'

export function * activateAccountSaga (): IterableIterator<
  SelectEffect |
  PutEffect |
  CallEffect
  > {
  try {
    const accountDetails = yield select(accountDetailsSelector)
    const activateAccountRequest = buildAccountActivationsRequest(accountDetails)
    yield put(activateAccountSent())
    yield call(AccountsApi.activateAccount, activateAccountRequest)
    yield put(activateAccountSuccess())
    yield put(setLoading(false))
    yield put(fetchActivations())
  } catch (err) {
    messageDispatcher.addError({
      text: get(err, 'response.data.description') || Errors.defaultError(localize.translate),
      err
    })
    yield put(setLoading(false))
    yield put(activateAccountFailed())
  }
}

export function * activateAccountInternalSaga (): IterableIterator<
  SelectEffect |
  PutEffect |
  CallEffect
  > {
  try {
    const accountDetails = yield select(accountDetailsSelector)
    const shouldSkipCRMFlow = yield select(isShouldSkipCRMFlow)

    const activateAccountRequest = buildInternalAccountActivationsRequest(accountDetails, shouldSkipCRMFlow)

    yield put(activateInternalAccountSent())
    yield call(AccountsApi.activateAccountInternal, activateAccountRequest)
    yield put(activateInternalAccountSuccess())
    yield put(setLoading(false))
    yield put(fetchActivations())
  } catch (err) {
    messageDispatcher.addError({
      text: get(err, 'response.data.description') || Errors.defaultError(localize.translate),
      err
    })
    yield put(setLoading(false))
    yield put(activateInternalAccountFailed())
  }
}

export function * updateAccountActivationSaga (): IterableIterator<
  SelectEffect |
  CallEffect |
  PutEffect
  > {
  try {
    const accountDetails = yield select(accountDetailsSelector)
    const activateAccountRequest = buildAccountActivationsRequest(accountDetails)
    yield call(AccountsApi.updateActivation, activateAccountRequest)
    yield put(updateAccountActivationSuccess())
    yield put(setLoading(false))
  } catch (err) {
    messageDispatcher.addError({
      text: get(err, 'response.data.description') || Errors.defaultError(localize.translate),
      err
    })
    yield put(setLoading(false))
    yield put(updateAccountActivationFailed())
  }
}

export default function * accountActivationSaga () {
  yield takeLatest(ACTIVATE_ACCOUNT, activateAccountSaga)
  yield takeLatest(ACTIVATE_ACCOUNT_INTERNAL, activateAccountInternalSaga)
  yield takeLatest(UPDATE_ACCOUNT_ACTIVATION, updateAccountActivationSaga)
}
